<template lang="pug">
  .module__main
    .module__title Список пользователей
    .module-content__container
      .users-control__block
        el-button.user-add__btn(type="primary" size="mini" @click="openUserAdding()") Добавить пользователя
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="users"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(prop="name" label="Логин" width="160" sortable)
            el-table-column(v-if="isAdmin" prop="role" label="Роль" width="100" sortable)
              template(slot-scope="scope")
                span {{ roles[scope.row.role] || scope.row.role }}
            el-table-column(v-if="isAdmin" label="Активен" width="100")
              template(slot-scope="scope")
                .user-active-change__btn(
                  @click="changeUserActiveStatus(scope.row)"
                  :class="scope.row.active ? 'active' : 'inactive'"
                  )
                  i.el-icon-check(v-if="scope.row.active")
                  i.el-icon-close(v-else)
            el-table-column(v-if="isAdmin" label="Лимит закрытия" width="200")
              template(slot-scope="scope")
                .limit__container(v-if="scope.row.role === 'support'")
                  span {{ `${scope.row.support_limit_filled}/${scope.row.support_limit_max}` }}
                  i.el-icon-refresh.limit__btn(@click="startResetSupportLimit(scope.row.id)")
                  i.el-icon-edit.limit__btn(@click="activateLimitChange(scope.row)")
    el-dialog(:visible.sync="isUserAdding" :before-close="resetUserAdding" title="Добавление пользователя" width="50%")
      AddUser(v-if="isUserAdding" :roles="roles" @resetUserAdd="resetUserAdding" @updateUsers="loadUsersList")
    el-dialog(v-if="isAdmin" :visible.sync="isLimitChanging" :before-close="resetLimitChange" title="Изменение максимального лимита" width="30%")
      .balance-dialog__container
        .title Введите лимит
        el-input(type="number" v-model="limitChange.value" placeholder="Лимит")
        .user-add__buttons
          el-button(type="success" @click="changeUserLimit()") Изменить
          el-button(type="danger" @click="resetLimitChange()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  CREATE_USER,
  EDIT_BALANCE,
  EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT
} from "../../store/const/user";
import AddUser from "./AddUser";
import instruments from '../../mixins/instruments';

export default {
  name: 'UsersList',
  components: {
    AddUser,
  },
  mixins: [
    instruments,
  ],
  data() {
    return {
      isUserAdding: false,
      isLimitChanging: false,
      limitChange: {
        user_id: null,
        user_name: '',
        value: 0,
      }
    }
  },
  mounted() {
    this.loadUsersList();
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('user', [
      'users',
      'isAdmin',
    ]),
    ...mapGetters('settings', [
      'roles',
    ]),
    isLoading() {
      return this.loading(LOAD_USERS_LIST) === 'loading';
    },
    isError() {
      return this.loading(LOAD_USERS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_USERS_LIST);
    },
  },
  methods: {
    ...mapActions('user', {
      loadUsersList: LOAD_USERS_LIST,
      addNewUser: CREATE_USER,
      editUser: EDIT_USER,
      editLimit: EDIT_SUPPORT_LIMIT,
      resetLimit: RESET_SUPPORT_LIMIT,
    }),
    openUserAdding() {
      this.isUserAdding = true;
    },
    resetUserAdding() {
      this.isUserAdding = false;
    },
    async changeUserActiveStatus(user) {
      this.$confirm(
          `Вы уверены, что хотите ${user.active ? 'деактивировать' : 'активировать'} пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.editUser({ id: user.id, data: { active: !user.active } });
        if (request.success) {
          this.$message.success('Пользователь успешно изменен');
          this.loadUsersList();
        } else {
          this.$message.error(`Ошибка изменения пользователя: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение пользователя отменено');
      });
    },
    activateLimitChange(user) {
      this.limitChange.user_id = user.id;
      this.limitChange.user_name = user.name;
      this.limitChange.value = user.support_limit_max;
      this.isLimitChanging = true;
    },
    resetLimitChange() {
      this.limitChange = {
        user_id: null,
        user_name: '',
        value: 0,
      };
      this.isLimitChanging = false;
    },
    async changeUserLimit() {
      this.$confirm(
          `Вы уверены, что хотите изменить лимит пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        if (!this.limitChange.value) {
          this.$message.info(`Введите лимит`);
          return;
        } else if (this.limitChange.value < 0) {
          this.$message.info('Значение должно быть положительным');
          return;
        }
        const request = await this.editLimit({
          id: this.limitChange.user_id,
          data: {
            value: this.limitChange.value,
          }
        });
        if (request.success) {
          this.$message.success('Лимит успешно изменен');
          this.loadUsersList();
          this.resetLimitChange();
        } else {
          this.$message.error(`Ошибка изменения лимита: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение лимита отменено');
      });
    },
    async startResetSupportLimit(user_id) {
      this.$confirm(
          `Вы уверены, что хотите сбросить лимит пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.resetLimit({ id: user_id });
        if (request.success) {
          this.$message.success('Лимит успешно сброшен');
          this.loadUsersList();
        } else {
          this.$message.error(`Ошибка сброса лимита: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Сброс лимита отменен');
      });
    },
  }
};
</script>
<style scoped>
.users-control__block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.user-add__btn {
  width: 160px;
}

.limit__btn {
  margin-left: 5px;
  cursor: pointer;
  font-weight: bold;
}
</style>
